import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useUsageRecord} from "../hooks/useUsageRecord.ts";
import {UsageRecord} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useUsageRecord();

    return (
        <FormDrawer
            record={{
                id: '',
                username: '',
                action: '',
                value: 0,
                recordId: '',
                usageType: '',
                recordType: '',
                created: new Date().toISOString(),
            } as UsageRecord}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
